import { Euler, Vector3 } from "three"
import { useRef } from "react"
import { useFrame } from "@react-three/fiber"
import { PerspectiveCamera } from "@react-three/drei"
import { damp3, dampE } from "maath/easing"
import { useCounterStore } from "./stores/CounterStore"
import { useCamTargetStore } from "./stores/CamTargetStore"

export default function PresentationCamera(props)
{
    const camera = useRef()
    let camTransforms = [//{position: [1.5, 2.7, -4.2], rotation: [0, 0, 0]},
                         {position: [0.5, 1.65, 3.2], rotation: [0, 0, 0]},            // Door
                         {position: [-1, 1.65, 2.5], rotation: [0, Math.PI/2, 0]},     // BigShelf
                         {position: [-2.05, 1.85, -1], rotation: [0, Math.PI/2, 0]},     // HexShelf 
                         {position: [1.5, 1.55, -1.25], rotation: [0, -Math.PI/2, 0]}, // LShelf
                         {position: [-.5, 1.65, 2.5], rotation: [0, -Math.PI/2, 0]},   // Counter
                         {position: [-2.62, 1.78, -.28], rotation: [0, Math.PI/2, 0]}, // HexShelf Zoom
                         {position: [0.5, 1.65, 3], rotation: [0, 0, 0]},
                         {position: [-1.6, 2.5, -3.85], rotation: [0, Math.PI/2, 0]},  // Far HexShelf
                         {position: [-0.67, 1.512, 0.62], rotation: [0, 0, 0]}]            // TV


    const camTargetPos = useCamTargetStore((state) => state.camTargetPosition)
    const camTransformId = useCounterStore((state) => state.camTransformId)
    useFrame((state, deltaTime) => {
        let _targetPos = camTransformId != 5 
                            ? new Vector3().fromArray(camTransforms[camTransformId%camTransforms.length].position) 
                            : camTargetPos
                            
        if (camera.current.position) {
            damp3(camera.current.position,
                  _targetPos,                  
                  .5,
                  deltaTime)
            dampE(camera.current.rotation,
                  new Euler().fromArray(camTransforms[camTransformId%camTransforms.length].rotation),
                  .5,
                  deltaTime)
        }
        return null
    })

    return <>
        <PerspectiveCamera ref={camera} fov={67} makeDefault position={ [-0.67, 1.53, 0.65] } />
    </>
}